class User {

  constructor(username, roles, uuid, center, centerHull) {
    this._username = username;
    this._roles = roles || [];
    this._uuid = uuid;
    this._center = center || [];
    this._centerHull = centerHull || [];
    this._messages = 0;
  }

  get username() {
    return this._username;
  };

  set username(username){
    this._username = username;
  };

  get uuid() {
    return this._uuid;
  };

  set uuid(uuid){
    this._uuid = uuid;
  };

  get messages(){
    return this._messages;
  };

  set messages(count){
    this._messages = count;
  };

  get roles(){
    return this._roles;
  }

  get center(){
    return this._center;
  }

  get centerHull(){
    return this._centerHull;
  }

  isAdmin(){
    return this._roles.indexOf("ROLE_ADMIN") > -1;
  };

  isCustodian(){
    return this._roles.indexOf("ROLE_CUSTODIAN") > -1;
  };

  isMonitor(){
    return this._roles.indexOf("ROLE_MONITOR") > -1;
  };

  isOfficer(){
   return this._roles.indexOf("ROLE_OFFICER") > -1;
  };

  isAssistent(){
    return this._roles.indexOf("ROLE_ASSISTENT") > -1;
  };

  /**
   * This function checks whether the user is permitted
   * to do certain things by comparing a 5 bit permission
   * string, e.g. 10010 where the first bit
   * represents the admin role, the second bit the monitor, third bit
   * the study officer, fourth bit the assistent role and the last bit
   * the custodian role. So 10010 means
   * this function can be used by admins and assistents.
   * @param perms the permission string
   */
  hasPermission(perms){
    var allowed = false;

    if (perms[0] === "1"){
      if (this.isAdmin()) {
        allowed = true;
      }
    }
    if (perms[1] === "1"){
      if (this.isMonitor()){
        allowed = true;
      }
    }
    if (perms[2] === "1"){
      if (this.isOfficer()){
        allowed = true;
      }
    }
    if (perms[3] === "1"){
      if (this.isAssistent()){
        allowed = true;
      }
    }
    if (perms[4] === "1"){
      if (this.isCustodian()){
        allowed = true;
      }
    }

    return allowed;
  };

  // builds a user object from the server's principal object
  static build(data) {
    var roles = data.coreUser.authorities.map(function(item){
      return item.authority;
    });

    return new User(
      data.coreUser.username,
      roles,
      data.uuid,
      data.center,
      data.centerHull
    );
  };
}

export default User;



// WEBPACK FOOTER //
// ./src/main/webapp-files/modules/app/services/user.js